export const DASHBOARD_ROLE_CONFIG = {
  none: {
    usage: 'none',
    label: 'None',
    charts: []
  },
  recurring: {
    usage: 'recurring',
    label: 'Recurring',
    charts: ['recurringChecks', 'heatmap']
  },
  inReview: {
    usage: 'in_review',
    label: 'In review',
    charts: ['currentCompliance', 'heatmap']
  },
  overdue: {
    usage: 'overdue',
    label: 'Overdue',
    charts: ['recurringChecks', 'heatmap']
  }
} as const;

export const DASHBOARD_ROLE_ORDER = [
  'none',
  'recurring',
  'inReview',
  'overdue'
] as const;

export const dashboardRoles = {
  none: DASHBOARD_ROLE_CONFIG.none.usage,
  recurring: DASHBOARD_ROLE_CONFIG.recurring.usage,
  inReview: DASHBOARD_ROLE_CONFIG.inReview.usage,
  overdue: DASHBOARD_ROLE_CONFIG.overdue.usage
} as const;

export const normalizeDashboardRole = (value?: string | null) => {
  const role = (value || 'none').toString().trim().toLowerCase();
  return Object.values(DASHBOARD_ROLE_CONFIG).some((entry) => entry.usage === role)
    ? role
    : 'none';
};
